var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
		'cassie-radio-panel-parent': _vm.panel
	}},[_c('v-radio',_vm._g(_vm._b({staticClass:"cassie-radio",class:{
			'cassie-radio-reverse-label': _vm.reverseLabel,
			'cassie-radio-panel': _vm.panel
		},attrs:{"data-testid":_vm.testId}},'v-radio',_vm.$props,false),_vm.$listeners)),_vm._t("radio-action")],2)}
var staticRenderFns = []

export { render, staticRenderFns }